module.exports = __webpack_public_path__ + "img/cycling.c3c3cdd1.svg";